import { Module } from '@nestjs/common';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { GymInfoModule } from './gym-info/gym-info.module';
import { SchemaxInfoModule } from './schemax-info/schemax-info.module';
import { WhatsappBroadCastModule } from './whatsapp-broad-cast/whatsapp-broad-cast.module';
import { appConfig } from '../../config';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ExcelImport } from './entity/excel-import.entity';

@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',//appConfig.database.type, have to fix tsconfig
      timezone: 'Z',
      host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      entities: [
        ExcelImport
      ],
      // synchronize: false,
      logging: false,
      extra: {
        connectionLimit: appConfig.database.poolLimit
      }
    }),
    WhatsappBroadCastModule, 
    SchemaxInfoModule, 
    GymInfoModule
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
